import * as React from 'react';
import { Button, Modal } from '../..';
import { signOut, useAuth } from '../../../context/authContext';

type ModalProps = {
  notice: string;
};

function SessionTimeoutPrompt({ notice }: ModalProps) {
  const [, dispatch] = useAuth();

  return (
    <Modal show>
      <div className="rounded-md bg-white tablet:w-[500px]">
        <form>
          <div className="flex flex-col px-5 pt-5 pb-7">
            <h3
              className="text-pos-black text-[20px] font-semibold mb-2
              inline-flex whitespace-pre"
            >
              You&apos;ve been logged out!
            </h3>

            <div className="text-pos-black text-base mb-2 font-normal space-y-4">
              <p>{notice}</p>
            </div>

            <div className="mt-8 text-center flex flex-row ml-auto space-x-4">
              <Button
                label="Login Again"
                onClick={() => signOut(dispatch, 'MANUAL')}
                type="button"
                disabled={false}
                className="!bg-pos-green border border-[rgba(27,31,36,0.15)] min-w-[150px]  h-[40px]
                      items-center justify-center text-white text-xbase
                      shadow-[0_1px_0_rgba(27,31,36,0.1),inset_0_1px_0_rgba(255,255,255,0.03)] shrink-0 font-medium"
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default SessionTimeoutPrompt;
